module.exports = __webpack_public_path__ + "static/gallery_kerry_3_thumb-c844101996ef8d973cd3c68aaeac585b.jpg";